import React from 'react';
import { appDomain } from "../../domain/domain";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { BaseComponent } from "../base/BaseComponent";
import { CalendarListItem } from "./CalendarListItem";

import { ButtonToolbar, Button, DropdownButton, Dropdown, ProgressBar } from "react-bootstrap";
import { ConfirmClearDialog } from '../core/ConfirmClearDialog';

interface CalendarListState {
    calendars?: ICalendar[],
    confirmClearCalendars: boolean;
}

export class CalendarList extends BaseComponent<{}, CalendarListState> {
    constructor(props: {}) {
        super(props);
        this.state = { confirmClearCalendars: false };
    }
    componentDidMount() {
        super.componentDidMount();
        this.loadData();
    }
    async loadData() {
        const calendars = await appDomain.calendarService.get();
        if (this.mounted) {
            this.setState({ calendars });
        }
    }
    async addCalendar() {
        const calendar: ICalendar = {
            id: String(Math.random()).slice(12),
            name: "Calendar" + (new Date().toISOString()),
            events: []
        };
        await appDomain.calendarService.save([calendar]);
        this.loadData();
    }
    async clearCalendars() {
        const calendars = this.state.calendars || [];
        for(const calendar of calendars) {
            await appDomain.calendarService.delete(calendar.id);
        }
        this.confirmClearCalendars(false);
        this.loadData();
    }
    confirmClearCalendars(confirmClearCalendars: boolean) {
        if (this.mounted) {
            this.setState({ confirmClearCalendars });
        }
    }
    calendarUpdated(calendar?: ICalendar) {
        this.loadData();
    }
    render() {
        const addCalendar = this.addCalendar.bind(this);
        const openDialog = () => this.confirmClearCalendars(true);
        const closeDialog = () => this.confirmClearCalendars(false);
        const clearCalendars = this.clearCalendars.bind(this);
        const calendarUpdated = this.calendarUpdated.bind(this);
        return (
            <div className="calendars">
                <div>
                    {(this.state.calendars || []).map((c) => <CalendarListItem key={c.id} calendar={c} onUpdate={calendarUpdated} />)}
                </div>

                <ButtonToolbar>
                    <Button variant="primary" onClick={addCalendar}>Add calendar</Button>
                    <Button variant="danger" onClick={openDialog}>Clear calendars</Button>
                </ButtonToolbar>

                <ConfirmClearDialog show={this.state.confirmClearCalendars}
                    title="Clear all calendars"
                    text="Are you sure you want to clear ALL calendars?"
                    onConfirm={clearCalendars}
                    onCancel={closeDialog}
                    />

<ButtonToolbar>
  <Button variant="primary">Primary</Button>
  <Button variant="secondary">Secondary</Button>
  <Button variant="success">Success</Button>
  <Button variant="warning">Warning</Button>
  <Button variant="danger">Danger</Button>
  <Button variant="info">Info</Button>
  <Button variant="light">Light</Button>
  <Button variant="dark">Dark</Button>
  <Button variant="link">Link</Button>
</ButtonToolbar>

<ProgressBar now={60} label={`60%`} className="mt-2" />

<ButtonToolbar>
  {['Primary', 'Secondary', 'Success', 'Info', 'Warning', 'Danger'].map(
    variant => (
      <DropdownButton
        title={variant}
        variant={variant.toLowerCase()}
        id={`dropdown-variants-${variant}`}
        key={variant}
      >
        <Dropdown.Item eventKey="1">Action</Dropdown.Item>
        <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
        <Dropdown.Item eventKey="3" active>
          Active Item
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item eventKey="4">Separated link</Dropdown.Item>
      </DropdownButton>
    ),
  )}
</ButtonToolbar>

                {/* <Modal show={this.state.confirmClearCalendars}>
                    <Modal.Header closeButton>
                        <Modal.Title>Clear all calendars</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to clear <b>ALL</b> calendars?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeDialog}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={clearCalendars}>
                            Move to Trash
                        </Button>
                    </Modal.Footer>
                </Modal>*/}
            </div>
          );
    }
}

